import React from 'react'

import { NavLink } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { VISIT_TYPE_DISPLAY_NAMES } from '../../utils'

import moment from 'moment'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const getDate = (visit) => {
	let start = visit.startDate ? moment(visit.startDate) : null
	let end = visit.type === 'boarding' && visit.endDate ? moment(visit.endDate) : moment(visit.startDate)

	if (start && end) {
		let startDay = start.format('D')
		let endDay = end.format('D')
		let startMonth = start.format('MMM')
		let endMonth = end.format('MMM')

		let endDateDisplay = ''

		if (visit.type === 'boarding') {
			endDateDisplay =
				startMonth === endMonth && endDay
					? ` - ${endDay}`
					: startMonth !== endMonth && endDay
					? ` - ${endMonth} ${endDay}`
					: null
		}

		return `${startMonth} ${startDay}${endDateDisplay}`
	}
}

const AppointmentMatchNavLinks = (props) => {
	const { selectedFacility, location, client, visit, roles } = props
	const isGroomer = roles.length === 1 && roles.includes('Groomer')
	const classes = useStyles()

	return (
		<div className={classes.crumbInt}>
			<NavLink
				className={classes.crumb}
				to={
					isGroomer
						? `/facilities/${selectedFacility ? selectedFacility._id : null}/groomingHome`
						: `/facilities/${selectedFacility ? selectedFacility._id : null}/${
								visit?.type === 'grooming' ? 'groomingHome' : 'schedule'
						  }`
				}>
				Home /
			</NavLink>

			<NavLink className={classes.crumb} to={`/clients`}>
				Clients /
			</NavLink>

			<NavLink className={classes.crumb} to={`/clients/${client ? client._id : null}/appointments`}>
				{client ? client.account.full_name : 'No Name'} /
			</NavLink>

			<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={location.pathname}>
				{`${getDate(visit)}${
					visit.type
						? VISIT_TYPE_DISPLAY_NAMES[visit.type]
							? ` ${VISIT_TYPE_DISPLAY_NAMES[visit.type]}`
							: ` ${visit.type.replace('_', ' ')}`
						: ''
				}`}{' '}
				/
			</NavLink>
		</div>
	)
}

export default AppointmentMatchNavLinks
